import {
    get,
    post
} from '@/utils/request'

const SERVICE_URL = '/project-service/v1'


export function purchaseTaskList(params) {
    return post(SERVICE_URL + '/purchaseTask/purchaseTaskList', params)
}

export function purchaseTaskListByStatus(params) {
    return post(SERVICE_URL + '/purchaseTask/purchaseTaskListByStatus', params)
}

//查询没有待分配的情况
export function purchaseList(params) {
    return post(SERVICE_URL + '/purchaseTask/purchaseList', params)
}

export function getPurchaseTaskById(params, pathParams) {
    return get(SERVICE_URL + '/purchaseTask/getPurchaseTaskById', params, pathParams)
}

export function deletePurchaseTask(params, pathParams) {
    return get(SERVICE_URL + '/purchaseTask/deletePurchaseTask', params, pathParams)
}
export function deletePurchaseTaskFei(params, pathParams) {
    return get(SERVICE_URL + '/purchaseTask/deletePurchaseTaskFei', params, pathParams)
}
export function backPurchaseTaskFei(params, pathParams) {
    return get(SERVICE_URL + '/purchaseTask/backPurchaseTaskFei', params, pathParams)
}

export function addPurchaseTask(params) {
    return post(SERVICE_URL + '/purchaseTask/insertPurchaseTask', params)
}

export function editPurchaseTask(params) {
    return post(SERVICE_URL + '/purchaseTask/updatePurchaseTask', params)
}

export function editPurchaseTaskCon(params) {
    return post(SERVICE_URL + '/purchaseTask/updatePurchaseTaskCon', params)
}

export function editPurchaseTaskSucc(params) {
    return post(SERVICE_URL + '/purchaseTask/updatePurchaseTaskSucc', params)
}

export function editPurchaseTaskFal(params) {
    return post(SERVICE_URL + '/purchaseTask/updatePurchaseTaskFal', params)
}

export function editPurchaseTaskRfq(params) {
    return post(SERVICE_URL + '/purchaseTask/editPurchaseTaskRfq', params)
}

export function exportPurchaseTaskList(params) {
    return post(SERVICE_URL + '/uploadFile/exportPurchaseTaskList', params)
}